export function evaluate(value, arg) {
    if (typeof value === 'function') {
        return value(arg);
    } else {
        return value;
    }
}